import React, { useState, useEffect } from "react";
import { Card, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Clasificacion.component.scss";

const ClasificacionComponent = ({ clasificacion }) => {
  const [estilo, setEstilo] = useState({
    width: "100%",
    height: "400px",
    backgroundImage: `url()`,
  });

  useEffect(() => {
    const { Url_Banner } = clasificacion.datos;
    setEstilo({
      width: "100%",
      height: "200px",
      backgroundSize: "cover",
      backgroundImage: `url(${Url_Banner})`,
    });
  }, [clasificacion]);

  return (
    <Link to={`/Catalogo/${clasificacion.datos.Cabecera}`}>
      <div className="Clasificacion">
        <div className="Clasificacion__Contenedor">
          <div className="Clasificacion__Contenedor--Contenido">
            <div style={estilo}>
              <div>
                <h5>{clasificacion.datos.Titulo}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ClasificacionComponent;
